import React, { type RefObject } from 'react'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import { CallQueueSection } from 'widgets/CallPopUp/ui/CallQueue/CallQueueSection/CallQueueSection'
import { Head } from 'widgets/CallPopUp/ui/components/Head/Head'
import styles from './styles.module.scss'

type ICallPopUpViewDefaultProps = {
  refWrap: RefObject<HTMLDivElement>
}

export const CallPopUpViewQueue: React.FC<ICallPopUpViewDefaultProps> = observer(({ refWrap }) => {
  const store = useCallPopUpDefaultContext()
  const { innerRefTooltipCurrent, callPopUpQueueStore } = store
  const name = callPopUpQueueStore.item?.team.name
  const number = callPopUpQueueStore.item?.team.number

  if (!callPopUpQueueStore.count) {
    return (
      <div className={styles.section}>
        <div className={styles.content}>
          <SpinnerLoader ariaLabel={'CallPopUpViewQueue'} />
        </div>
      </div>
    )
  }

  return (
    <div className={styles.section}>
      <div ref={refWrap} className={styles.tooltipWrap} />

      <Head
        isIncoming={true}
        wrapElement={innerRefTooltipCurrent}
        name={name}
        phone={number}
        onClick={store.handleGoToConversation}
      />

      <CallQueueSection type={'queue'} />
    </div>
  )
})
